module.exports = __webpack_public_path__ + "20f00602c0b8c3f10fc7ee02636f6485.pdf";